import React, { useImperativeHandle, useRef } from "react";
import { RCCAlert, RCCHookToast, RCCRefModalProps} from "react-common-components";
import { useForm } from "react-hook-form";
import ModalTreeHierarchyMaps from "src/components/ModalTreeHierarchyMaps";
import { useTranslation } from "src/context/Translations/context";
import { MapsHierarchyTypes } from "src/pages/StrategicPlanning/Maps/interface";

interface IModalActionsHierarchyMaps{
    onCallback: (obj: { iniciative?: number; objective?: number; } ) => void; 
}

export interface IRefModalActionsHierarchyMaps{
    openModalActionsHierarchyMaps: () => void;
}

const ModalActionsHierarchyMaps: React.ForwardRefRenderFunction<IRefModalActionsHierarchyMaps, IModalActionsHierarchyMaps> = ({
	onCallback
}, ref) => {
	const { translate } = useTranslation(); 
	const { addToast } = RCCHookToast();
	const modalActionsHierarchyMaps = useRef<RCCRefModalProps>(null);

	const { 
		handleSubmit, 
		register,
		reset,
		unregister
	} = useForm();

	const onSubmit = async (data: any) => {
		if(Object.keys(data).length !== 0 ){
			const objectives = Object.values(data[`selectedItens-${MapsHierarchyTypes.OBJECTIVES}`])?.filter((item: any) => typeof item === "string");
			const iniciatives = Object.values(data[`selectedItens-${MapsHierarchyTypes.INICIATIVES}`])?.filter((item: any) => typeof item === "string");
			const objectivesLength = objectives !== undefined ? objectives.length : 0;
			const iniciativesLength = iniciatives !== undefined ? iniciatives.length : 0;

			if(objectivesLength + iniciativesLength > 1){
				addToast({
					color: "yellow",
					description: translate("Selecione apenas um objetivo ou iniciativa"),
					title: translate("Atenção")
				});
				return;
			}

			const dataObjective = objectives !== undefined ? objectives[0] : undefined;
			const dataIniciative = iniciatives !== undefined ? iniciatives[0] : undefined;

			if(dataObjective === undefined && dataIniciative === undefined){
				addToast({
					color: "yellow",
					description: translate("Selecione uma iniciativa ou objetivo"),
					title: translate("Atenção")
				});
				return;
			}

			onCallback({
				iniciative: dataIniciative && dataObjective === undefined ? Number(dataIniciative) : undefined,
				objective: dataObjective ? Number(dataObjective) : undefined
			});
		}
		modalActionsHierarchyMaps.current?.closeModal();
	};

	const openModalActionsHierarchyMaps = async () => {
		reset();
		modalActionsHierarchyMaps.current?.openModal();
	};

	useImperativeHandle(ref, () => ({
		openModalActionsHierarchyMaps
	}));

	return (
		<ModalTreeHierarchyMaps 
			ref={modalActionsHierarchyMaps}
			onSubmit={handleSubmit(onSubmit)}
			register={register}
			checkLevelHierarchy = {[MapsHierarchyTypes.OBJECTIVES, MapsHierarchyTypes.INICIATIVES]}
			lastLevelHierarchy={MapsHierarchyTypes.INICIATIVES} 
			nodeContent={<RCCAlert 
				description={translate("Caso seja selecionado um objetivo, será criado uma iniciativa e uma respectiva ação dentro dela. Caso seja escolhido uma iniciativa, será cadastrada a ação diretamente na iniciativa")}
			/>}
			selectOptions="single"
			unregister={unregister}
		/>
	);
};

export default React.forwardRef(ModalActionsHierarchyMaps);
